<template>
  <card class="challenge-progress-card" :has-content-padding="false">
    <div class="personal-progress-bar">
      <div class="headline">{{ headline }}</div>
      <progress-bar
          cashflow-category="tracking"
          left-label="מתוך"
          :left-amount="challengeGoal"
          right-label="יצאו"
          :right-amount="spent"
          :show-warning-if-exceeding-amount="true"/>
    </div>
    <template v-slot:footer v-if="canAddExpense">
      <div class="button-wrapper">
        <riseup-button class="add-expense-button" :title="'הוספת הוצאה'" :action="openAddExpenseModal"/>
      </div>
    </template>
  </card>
</template>

<script>

import BaseUI from 'base-ui';
import { mapActions } from 'vuex';
import AddExpense
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/AddExpense';
import ProgressBar
  from '../../navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/ProgressBar';

export default {
  name: 'ChallengeProgressCard',
  components: {
    ProgressBar,
    RiseupButton: BaseUI.RiseupButton,
    Card: BaseUI.Card,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    challengeGoal: {
      type: Number,
      required: true,
    },
    spent: {
      type: Number,
      default: 0,
    },
    canAddExpense: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    openAddExpenseModal() {
      this.openModal({
        component: AddExpense,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';
.challenge-progress-card {
  background-color: $riseup-white;
  .personal-progress-bar {
    @include responsive-padding;
    padding-top: 24px;
    padding-bottom: 24px;
    .headline {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 18px;
      text-align: right;
    }
  }
  .button-wrapper {
    padding-bottom: 24px;
    padding-top: 24px;
    .add-expense-button {
      width: 100%;
      height: 60px;
    }
  }
}

</style>
